import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { CategoryOverviewProps } from "./types";

export const CategoryOverview = forwardRef<HTMLDivElement, CategoryOverviewProps>(
  ({ overview, isComparisionMode, overviewHeight, minOverviewHeight }, ref) => {
    const { t } = useTranslation("voiceek_ui");
    const formattedOverview = overview?.replaceAll(String.raw`\n`, "\n") ?? "";

    return (
      <div className="flex flex-col w-full gap-2.5">
        <div className="w-full h-[30px] px-[10px] font-bold text-white bg-[#293d72] rounded-[5px] leading-[30px]">
          {t("analysis.categorySummary.summary")}
        </div>

        <div
          ref={ref}
          className="px-[10px] text-black leading-[1.8] whitespace-pre-line"
          style={isComparisionMode
            ? {
              height: overviewHeight ? `${overviewHeight}px` : "auto",
              minHeight: minOverviewHeight ? `${minOverviewHeight}px` : "auto",
            }
            : {}}
        >
          {formattedOverview}
        </div>
      </div>
    );
  },
);

CategoryOverview.displayName = "CategoryOverview";
